import getCountryCode from '~/utils/countryCode'

export const getChargemapUrl = (path?: string, locale?: string) => {
    const { CHARGEMAP_URL, CHARGEMAP_DOMAIN } = useRuntimeConfig().public

    const isDev = process.env.NODE_ENV === 'development'

    if (locale === 'en') {
        return `${CHARGEMAP_URL}${path ?? ''}`
    }

    return locale
        ? `http${isDev ? '' : 's'}://${locale}.${CHARGEMAP_DOMAIN}${path ?? ''}`
        : `${CHARGEMAP_URL}${path ?? ''}`
}

export const getLocalUrl = (locale?: string, path?: string) => {
    const { CHARGEMAP_DOMAIN, NODE_ENV } = useRuntimeConfig().public

    const isDev = NODE_ENV === 'development'

    return `http${isDev ? '' : 's'}://${isDev ? '' : 'map.'}${CHARGEMAP_DOMAIN}${locale ? '/' + locale : ''}${path || ''}`
}

export const getAppStoreChargemapUrl = (locale: string) =>
    `https://itunes.apple.com/${getCountryCode(locale)}/app/chargemap-bornes-de-recharge/id438176982`

export const getPlayStoreChargemapUrl = (locale: string) =>
    `https://play.google.com/store/apps/details?id=com.chargemap_beta.android&hl=${locale}`
